import React, { useState, useEffect } from "react";
import {
  Link,
  useParams
} from "react-router-dom";
import {
  useNavigate} from "react-router-dom";
import axios from "axios";
import Cookies from 'js-cookie';
import Modal from './module.modal';
import styles from './modules/accountblock/accountblock.module.css';
import Config from "../Config.json"
import {ReactComponent as Logo} from "../static/svg/expo-logo.svg" 
import Loader from "../static/svg/loader.svg";
import AccountBlock from "./modules/accountblock";
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import { Fragment } from "react/cjs/react.production.min";
import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz';
import { use } from "react";

function Account(props) {
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(true);
    const [formError, setFormError] = useState();
    const [subscriber, setSubscriber] = useState({});
    
    useEffect(() => {
      setShowLoader(false);
    }, []);

    useEffect(() => {
      console.log(props.user)

      if (props.user.org && props.user.org.subscription) {
        setSubscriber(props.user.org.subscription)
      }
    }, [props.user])


    function handleBackBtn(){
      navigate('/narratives/')

    }

    function logout(){
       function removeAllCookies() {
        const allCookies = Cookies.get(); // Get an object containing all cookies

        for (const cookieName in allCookies) {
            if (Object.hasOwnProperty.call(allCookies, cookieName)) {
            const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            const cookieOptions = {
                sameSite: 'Lax'
            };
            
            if (isLocalhost) {
                // For localhost, don't set domain (defaults to current hostname)
                cookieOptions.secure = false; // Allow HTTP for local dev
            } else {
                // For production, use the expostudio.co domain
                cookieOptions.domain = '.expostudio.co';
                cookieOptions.secure = true; // Require HTTPS for production
            }

            Cookies.remove(cookieName, cookieOptions); 
            // If your cookies were set with specific path or domain, 
            // you need to provide those options to Cookies.remove()
            // e.g., Cookies.remove(cookieName, { path: '/', domain: '.yourdomain.com' });
            }
        }
        }
        removeAllCookies();
        localStorage.removeItem('user')

      window.location.href = "/login/";
    }

    return (
      <section className="main" id="accountPage">
      {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

      {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}


       {subscriber && <div className="col appGrid">
      
            <div id="narrativeTools">
      
              <h1>Account</h1>
      
      
              </div>
                <nav className="leftNav">
                
      
                  <div className="leftArrow iconField" onClick={() => handleBackBtn()}>
                    <ArrowBack className="icon" /> 
      
                    <div className="pages">Back</div>
                  </div>
      
                
                </nav>
                <div className="core">
      
                <div className="flex flexColumn">

                  {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

                  {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

         
                  <div className={`${styles.blockGrid}`}>
                      <AccountBlock 
                          icon={props.user && props.user.username?<span className={styles.accountBlockAvatar}>{props.user.username.charAt(0)}</span>:null}
                          heading={props.user?props.user.username:""}
                          text={"Manage your account and subscription"}
                          cta={"Account Info"}
                          link={'/account/general/'}
                          target={null}
                          background={"#2B2B2B"}
                          orientation={"vertical"}
                      ></AccountBlock>

                      <AccountBlock 
                          icon={""}
                          heading={"Web App"}
                          text={"Open the Expo Studio web application"}
                          cta={"Open"}
                          link={"https://www.expostudio.co"}
                          target={"_blank"}
                          background={"#0069A6"}
                          orientation={"vertical"}
                      ></AccountBlock>
                    </div>

                    <div className={"flex gap20"}>
                      <p>Build</p> <p><strong>{`${Config.buildMajor}.${Config.buildMinor}.${Config.buildRevision}`}</strong></p>  
                    </div>

                    <div className={"flex"}>               
                      <div className={`expo-pill-btn`} onClick={logout}> Logout </div>
                    </div>
     
                 

                 
                </div>
            </div>
        </div>}    
      

    </section>
    );
}

export default Account;

// <a href="/reset-password/" className="reset">Reset Password</a>